import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import partial from 'transmute/partial';
import { COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES } from 'customer-data-objects/property/PropertyListTypes';
import DnDPreviewItem from 'crm_components/dialog/propertyListEditor/DnDPreviewItem';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
import { Column } from 'foundations-components/transitional/components/Column';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DEAL, TICKET } from 'customer-data-objects/constants/ObjectTypes';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TYPE_PRO_PQL_KEY = {
  [DEAL]: 'SalesProPQL',
  [TICKET]: 'ServiceProPQL'
};
class PreviewRow extends Component {
  constructor(...args) {
    super(...args);
    this.renderCheckbox = () => {
      const {
        value,
        type,
        onRequiredChange: handleRequiredChange,
        requirable
      } = this.props;

      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      const pqlKey = TYPE_PRO_PQL_KEY[type] || 'SalesProPQL';
      const tooltip = value.requiredDisabled ? I18n.text(`crm_components.PropertyListEditor.disabledReason.${type}`) : I18n.text(`crm_components.${pqlKey}.requiredFields.tooltip`);
      return /*#__PURE__*/_jsx(Column, {
        marginInlineStart: "400",
        marginInlineEnd: "1000",
        children: /*#__PURE__*/_jsx(Tooltip, {
          disabled: !value.requiredDisabled && requirable,
          title: tooltip,
          children: /*#__PURE__*/_jsx(Checkbox, {
            checked: value.required,
            disabled: value.requiredDisabled || !requirable,
            innerPadding: "none",
            onChange: partial(handleRequiredChange, value),
            marginInlineEnd: "200"
          })
        })
      });
    };
    this.renderRow = () => {
      let checkBoxElement = null;
      if ([CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES].includes(this.props.use)) {
        checkBoxElement = this.renderCheckbox();
      }
      return /*#__PURE__*/_jsxs(ColumnWrapper, {
        align: "center",
        marginBlockEnd: "300",
        children: [/*#__PURE__*/_jsx(ColumnSpreads, {
          overflow: false,
          children: /*#__PURE__*/_jsx(DnDPreviewItem, {
            index: this.props.index,
            onAddOption: this.props.onAddOption,
            objectType: this.props.type,
            onDrop: this.props.onSave,
            onMove: this.props.onReorderOption,
            onRemove: partial(this.props.onRemoveOption, this.props.value),
            onReset: this.props.onReset,
            onInvalidDrop: this.props.onReset,
            option: this.props.value
          })
        }), checkBoxElement]
      }, this.props.value);
    };
    this.renderLockedRow = () => {
      let checkBoxElement = null;
      if ([CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES].includes(this.props.use)) {
        checkBoxElement = this.renderCheckbox();
      }
      return /*#__PURE__*/_jsxs(ColumnWrapper, {
        align: "center",
        marginBlockEnd: "300",
        children: [/*#__PURE__*/_jsx(ColumnSpreads, {
          children: /*#__PURE__*/_jsx(DnDPreviewItem, {
            index: this.props.index,
            option: this.props.value
          })
        }), checkBoxElement]
      }, this.props.value);
    };
  }
  render() {
    if (this.props.disabled) {
      return this.renderLockedRow();
    }
    return this.renderRow();
  }
}
PreviewRow.displayName = 'PreviewRow';
PreviewRow.propTypes = {
  disabled: PropTypes.bool,
  onAddOption: PropTypes.func.isRequired,
  onRemoveOption: PropTypes.func.isRequired,
  onReorderOption: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRequiredChange: PropTypes.func,
  requirable: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  use: PropTypes.oneOf([COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES]).isRequired,
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};
export default PreviewRow;